<template>
    <div>
        <div>
            <div :class="captionTextClasses">{{label.replace('_',' ')}}</div>
            <div :class="valueTextClasses"><div class="pt-1 pb-1">XXXXXXXXX</div></div>
            <div :class="captionTextClasses">{{hint}}</div>
        </div>
    </div>

</template>

<script>

    export default {

        props: {
            label: {
                type: String,
                required: true
            },
            hint: {
                type: String,
                required: false,
                default: '',
            },
            prependIcon: {
                type: String,
                required: false,
                default: null,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        computed: {
            captionTextClasses() {
                return this.disabled ? 'caption grey--text' : 'caption grey--text text--lighten-1';
            },
            valueTextClasses() {
                return this.disabled ? 'value-input grey--text' : 'value-input grey--text text--lighten-1';
            },
            iconColor() {
                return this.disabled ? 'grey' : 'grey lighten-1';
            }
        }
    }
</script>

<style scoped>
    .masked-input {
        width: 34px;
        height: 82px;
        float: left;
        display:inline-block;
        padding-right: 10px;
    }

    .value-input {
        font-size: 16px
    }

</style>
